var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchooltrack3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_51422",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#79266a",
    floodOpacity: 0.141,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35850",
    "data-name": "Group 35850",
    transform: "translate(-50 -98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35849",
    "data-name": "Group 35849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31148",
    "data-name": "Group 31148",
    transform: "translate(49.732 97.732)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.27, 0.27)",
    filter: "url(#Path_51422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_51422-2",
    "data-name": "Path 51422",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36 1 C 31.27458953857422 1 26.69105911254883 1.925247192382812 22.37673187255859 3.75006103515625 C 18.20906829833984 5.512832641601562 14.46591949462891 8.036598205566406 11.25125885009766 11.25125885009766 C 8.036598205566406 14.46591949462891 5.512832641601562 18.20906829833984 3.75006103515625 22.37673187255859 C 1.925247192382812 26.69105911254883 1 31.27458953857422 1 36 C 1 40.72541046142578 1.925247192382812 45.30894088745117 3.75006103515625 49.62326812744141 C 5.512832641601562 53.79093170166016 8.036598205566406 57.53408050537109 11.25125885009766 60.74874114990234 C 14.46591949462891 63.96340179443359 18.20906829833984 66.48716735839844 22.37673187255859 68.24993896484375 C 26.69105911254883 70.07475280761719 31.27458953857422 71 36 71 C 40.72541046142578 71 45.30894088745117 70.07475280761719 49.62326812744141 68.24993896484375 C 53.79093170166016 66.48716735839844 57.53408050537109 63.96340179443359 60.74874114990234 60.74874114990234 C 63.96340179443359 57.53408050537109 66.48716735839844 53.79093170166016 68.24993896484375 49.62326812744141 C 70.07475280761719 45.30894088745117 71 40.72541046142578 71 36 C 71 31.27458953857422 70.07475280761719 26.69105911254883 68.24993896484375 22.37673187255859 C 66.48716735839844 18.20906829833984 63.96340179443359 14.46591949462891 60.74874114990234 11.25125885009766 C 57.53408050537109 8.036598205566406 53.79093170166016 5.512832641601562 49.62326812744141 3.75006103515625 C 45.30894088745117 1.925247192382812 40.72541046142578 1 36 1 M 36 0 C 55.88224792480469 0 72 16.11774826049805 72 36 C 72 55.88224792480469 55.88224792480469 72 36 72 C 16.11774826049805 72 0 55.88224792480469 0 36 C 0 16.11774826049805 16.11774826049805 0 36 0 Z",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_51422-3",
    "data-name": "Path 51422",
    transform: "translate(0.268 0.268)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36 1 C 31.27458953857422 1 26.69105911254883 1.925247192382812 22.37673187255859 3.75006103515625 C 18.20906829833984 5.512832641601562 14.46591949462891 8.036598205566406 11.25125885009766 11.25125885009766 C 8.036598205566406 14.46591949462891 5.512832641601562 18.20906829833984 3.75006103515625 22.37673187255859 C 1.925247192382812 26.69105911254883 1 31.27458953857422 1 36 C 1 40.72541046142578 1.925247192382812 45.30894088745117 3.75006103515625 49.62326812744141 C 5.512832641601562 53.79093170166016 8.036598205566406 57.53408050537109 11.25125885009766 60.74874114990234 C 14.46591949462891 63.96340179443359 18.20906829833984 66.48716735839844 22.37673187255859 68.24993896484375 C 26.69105911254883 70.07475280761719 31.27458953857422 71 36 71 C 40.72541046142578 71 45.30894088745117 70.07475280761719 49.62326812744141 68.24993896484375 C 53.79093170166016 66.48716735839844 57.53408050537109 63.96340179443359 60.74874114990234 60.74874114990234 C 63.96340179443359 57.53408050537109 66.48716735839844 53.79093170166016 68.24993896484375 49.62326812744141 C 70.07475280761719 45.30894088745117 71 40.72541046142578 71 36 C 71 31.27458953857422 70.07475280761719 26.69105911254883 68.24993896484375 22.37673187255859 C 66.48716735839844 18.20906829833984 63.96340179443359 14.46591949462891 60.74874114990234 11.25125885009766 C 57.53408050537109 8.036598205566406 53.79093170166016 5.512832641601562 49.62326812744141 3.75006103515625 C 45.30894088745117 1.925247192382812 40.72541046142578 1 36 1 M 36 0 C 55.88224792480469 0 72 16.11774826049805 72 36 C 72 55.88224792480469 55.88224792480469 72 36 72 C 16.11774826049805 72 0 55.88224792480469 0 36 C 0 16.11774826049805 16.11774826049805 0 36 0 Z",
    stroke: "none",
    fill: "#adc927"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35714",
    "data-name": "Group 35714",
    transform: "translate(-5936.48 -2204.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_101134092916352404764514",
    "data-name": 1.011340929163524e+23,
    transform: "translate(6007.535 2325.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55172",
    "data-name": "Path 55172",
    d: "M86.418,111.9H78.945a1.661,1.661,0,1,1,0-3.321h7.473a4.152,4.152,0,0,0,0-8.3H71.473a7.473,7.473,0,0,1,0-14.945h6.642a1.661,1.661,0,1,1,0,3.321H71.473a4.152,4.152,0,0,0,0,8.3H86.418a7.473,7.473,0,0,1,0,14.945Z",
    transform: "translate(-64 -85.333)",
    fill: "#c7e64b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_9",
    "data-name": "Intersection 9",
    d: "M14.945,31.923a1.66,1.66,0,1,1,0-3.321h4.961A43.834,43.834,0,0,1,16.2,31.923ZM25.354,21.514A4.153,4.153,0,0,0,22.418,20.3H7.473a7.473,7.473,0,0,1,0-14.945h6.642a1.661,1.661,0,1,1,0,3.321H7.473a4.152,4.152,0,1,0,0,8.3H22.418a7.473,7.473,0,0,1,5.04,1.956c-.566.962-1.18,1.921-1.844,2.867Q25.491,21.652,25.354,21.514Zm-2.49-6.936c-.2-.156-4.781-3.881-4.781-8.78a5.819,5.819,0,0,1,11.639,0c0,4.9-4.585,8.625-4.78,8.78a1.663,1.663,0,0,1-2.078,0ZM22.14,4.036A2.5,2.5,0,0,0,21.408,5.8c0,2.119,1.452,4.062,2.494,5.185C24.945,9.86,26.4,7.916,26.4,5.8A2.493,2.493,0,0,0,22.14,4.036Z",
    transform: "translate(6007.535 2319.652)",
    fill: "#abc73e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_8",
    "data-name": "Intersection 8",
    d: "M2.188,12.757A7.473,7.473,0,0,1,7.473,0h6.643A1.656,1.656,0,0,1,14.4.025c-.7,1.077-1.482,2.195-2.322,3.3H7.473a4.152,4.152,0,0,0-2.538,7.437c-.892.734-1.8,1.427-2.683,2.061Z",
    transform: "translate(6007.535 2325.005)",
    fill: "#869b34"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_55179",
    "data-name": "Path 55179",
    d: "M69.819,313.882a1.659,1.659,0,0,1-1.039-.365c-.2-.156-4.781-3.88-4.781-8.78a5.819,5.819,0,0,1,11.639,0c0,4.9-4.585,8.624-4.781,8.78a1.659,1.659,0,0,1-1.039.365Zm0-11.639a2.5,2.5,0,0,0-2.494,2.494c0,2.118,1.451,4.061,2.494,5.185,1.042-1.122,2.494-3.066,2.494-5.185a2.5,2.5,0,0,0-2.494-2.494Z",
    transform: "translate(7.175 -161.433)",
    fill: "#79266a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchooltrack3);
export default __webpack_public_path__ + "static/media/schooltrack3.b8318487eda8a89e9ffd3ebf1591e210.svg";
export { ForwardRef as ReactComponent };